// Polling
export const POLL_FAST_INTERVAL_MS = 2000;
export const POLL_SLOW_INTERVAL_MS = 5000;
// Most exports land inside this window; past it the wait is measured in minutes.
export const POLL_BACKOFF_AFTER_MS = 30 * 1000;
// A budget rather than an attempt count, so retuning the intervals above keeps the
// intent. The server keeps working past it either way.
export const POLL_BUDGET_MS = 5 * 60 * 1000;

// Download
export const FALLBACK_FILENAME = "time-spent-in-cards.csv";

// Messages
export const PREPARING_MESSAGE = "Preparing your download…";
export const STILL_PREPARING_MESSAGE = "Still preparing your download — large exports can take a few minutes.";
export const READY_MESSAGE = "Download ready";
export const GENERIC_ERROR = "We could not prepare your download. Please try again.";
// Running out of budget is not a failure, so we don't ask the user to retry and
// enqueue the work twice.
export const TIMEOUT_MESSAGE = "Your export is taking longer than usual. It is still being "
    + "prepared. Check back in a few minutes.";

// The file repeats this on its last row, for whoever opens it later.
export const truncatedMessage = rowCount =>
    `Downloaded the top ${rowCount.toLocaleString()} cards by time spent.`;
